import React from "react";
import { usePage } from "../../context/PageContext";

const BLOCKS = [
  { type: "text", label: "Text", hint: "Paragraph or notes" },
  { type: "image", label: "Image", hint: "URL and caption" },
  { type: "header", label: "Heading", hint: "Large title" },
  { type: "markdown", label: "Markdown", hint: "Rich formatted copy" },
];

const Palette = () => {
  const { addBlock } = usePage();

  return (
    <div>
      <p className="palette-heading">Add blocks</p>
      <div className="palette-list">
        {BLOCKS.map(({ type, label, hint }) => (
          <div
            key={type}
            role="button"
            tabIndex={0}
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData("blockType", type);
            }}
            onClick={() => addBlock(type)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                addBlock(type);
              }
            }}
            className={`palette-item palette-item--${type}`}
          >
            <span className="palette-item-label">{label}</span>
            <span className="palette-item-hint">{hint}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Palette;
